module.exports = __webpack_public_path__ + "img/photo2_3.fea1452e.jpg";